<template lang="pug">
  .component-backoffice-zone-list.component-backoffice-category-list
    .row.column
      .row
        .column.small-12.large-6.category(v-for="(zone, index) in zones")
          .inner-content.card
            .row
              .column.shrink
                  dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                    .dropdown-buttons
                      a.button(@click="deleteZone") Delete
                      //a.button(@click="editZone") Edit
                      ModalReveal(ref="revealGeoJson")
                        button.button(slot="trigger", @click="showGeoJson") Copy GeoJson to clipboard
                        .row
                          .column
                            loading-spinner(v-if="spin")
                            textarea(v-else :value ='geoJson' id="geoJsonToCopy" rows=30)
                        .row
                          .column
                            button.button(@click="copyToClipboard" :disabled="geoJson===''") Copy to clipboard
              .column
                div Z{{zone.id}}
                div
                  router-link(:to="{name:'edit-zone', params:{id:zone.id}}")
                    h3 {{ zone.name }} &nbsp;
</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import GoogleMap from '../../lib/map/GoogleMap'
import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
import MaggieHelper from '../../maggieHelper'
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import ActionButton from "../../components/structure/ui/ActionButton";
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import Dropdown from "../../components/structure/foundation/Dropdown.vue";

export default {
  name: 'ZoneList',
  components: {Dropdown, LoadingSpinner, GoogleMap, GoogleMapPolygon, ModalReveal, ActionButton},
  data() {
    return {
      activeIndex: 0,
      zones: [],
      mapsApiKey: window.env.GOOGLE_MAPS_KEY,
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      geoJson: '',
      spin: true,
      geoJsonMerged: '',
    }
  },
  created() {
    KeplerBackofficeSdk.configuration.get((data) => {
      this.mapCenter.lat = data.application.application_default_latitude.value
      this.mapCenter.lng = data.application.application_default_longitude.value
    })
    this.loadZones()
  },
  methods: {
    loadZones() {
      KeplerBackofficeSdk.zones.list.all((data) => {
        this.zones = data
      })
    },
    deleteZone() {
      var zone = this.zones[this.activeIndex]
      this.$confirm('Are you sure?', `Do you really want to delete Z${zone.id} - ${zone.name}?`, () => {

        KeplerBackofficeSdk.zones.select(zone.id).remove((data) => {
          this.loadZones()
          MaggieHelper.notification('zone-delete', 'Zone deleted successfully')
          this.activeIndex = 0
        })
      })
    },
    showGeoJson() {
      this.geoJson = ''
      this.spin =  true
      var zone = this.zones[this.activeIndex]
      KeplerBackofficeSdk.zones.select(zone.id).getGeoJson((data) => {
        this.geoJson = JSON.stringify(data)
        this.spin = false
      })

    },
    copyToClipboard() {
        document.getElementById('geoJsonToCopy').select()
        document.execCommand("copy")
        MaggieHelper.notification('GeoJson copied to Clipboard')
    },
  }
}
</script>

<style scoped lang="sass">
.component-backoffice-zone-list
  .map
    height: 400px

  //.zone-edit
    color: white

</style>



// WEBPACK FOOTER //
// ZoneList.vue?44a098b6